/* eslint-disable */

import React from "react";

import { useNavigate, useParams } from "react-router-dom";

import Article001 from "../stratus-blog-article/article-001-what-is-a-charity.tsx";
import Article002 from "../stratus-blog-article/article-002-how-does-raindrop-work.tsx";
import Article003 from "../stratus-blog-article/article-003-what-is-a-waterfall.tsx";
import {
  ShnoodleImage,
  ShnoodleImageType,
} from "../../../ui-components/shnoodle-image/shnoodle-image.tsx";

import RaindropCard from "../../../ui-components/raindrop-card/raindrop-card.tsx";
import RaindropClickable from "../../../ui-components/raindrop-clickable/raindrop-clickable.tsx";
import RaindropHeading from "../../../ui-components/raindrop-heading/raindrop-heading.tsx";
import RaindropTextHeading1 from "../../../ui-components/raindrop-text-heading-1/raindrop-text-heading-1.tsx";
import RaindropTextParagraph from "../../../ui-components/raindrop-text-paragraph/raindrop-text-paragraph.tsx";

const BlogArticleLink = ({
  title = "What is Raindrop, anyway?",
  subtitle = "You'll have to wait and see",
  articleSlug = "#",
  dateString = "12th October 2021",
  isComingSoon = false,
  shnoodleType = ShnoodleImageType.Unknown,
}) => {
  const navigate = useNavigate();
  let opacityClass = "opacity-100";
  let hoverClass =
    "cursor-pointer hover:bg-color-dark-background-tertiary hover:scale-95";

  if (isComingSoon) {
    opacityClass = "opacity-30";

    hoverClass = "";
  }
  return (
    <RaindropClickable
      onClick={() => {
        navigate("/stratus/blog/" + articleSlug);
      }}
    >
      <RaindropCard>
        <div className="flex flex-row gap-4 items-center w-full">
          <ShnoodleImage shnoodleType={shnoodleType} isSmall={true} />
          <div className="flex flex-col gap-2 w-full text-left ">
            <h1 className="font-bold text-2xl">{title}</h1>

            <div className="flex flex-row gap-2 items-center  text-sm text-color-dark-text-secondary">
              <h3>5 min read</h3>
              <div className="aspect-square w-1 bg-color-dark-text-secondary rounded-full" />
              {isComingSoon ? <h4>Coming Soon</h4> : <h4>{dateString}</h4>}
            </div>
          </div>
        </div>
      </RaindropCard>
    </RaindropClickable>
  );
};

const StratusBlog = () => {
  const { articleSlug } = useParams();

  const slugMap = {
    "what-is-a-charity": <Article001 />,
    "how-does-raindrop-work": <Article002 />,
    "what-is-a-waterfall": <Article003 />,
  };

  if (articleSlug) {
    return slugMap[articleSlug];
  }

  return (
    <div
      id={"raindrop-website-global"}
      className={
        "flex flex-col w-full items-center  overflow-x-clip pt-12 gap-12"
      }
    >
      <div className="flex flex-col gap-8 items-center">
        <h1 className="text-6xl font-bold">The Raindrop Blog</h1>

        <RaindropTextParagraph>
          The Raindrop mascot, Shnoodle, has so many questions. Let's try answer
          them together.{" "}
        </RaindropTextParagraph>
        <RaindropTextParagraph>
          No jargon, no judgement, just simple answers to complex questions.
        </RaindropTextParagraph>
      </div>

      <div className="flex flex-col gap-4 w-full max-w-[600px]">
        <BlogArticleLink
          title={"So, how does Raindrop work?"}
          articleSlug={"how-does-raindrop-work"}
          dateString={"2nd March 2025"}
          subtitle="Shnoodle is confused by this pink circle he's seeing everywhere."
          shnoodleType={ShnoodleImageType.WateringCan}
        />
        <BlogArticleLink
          title={"What is a Raindrop Waterfall?"}
          articleSlug={"what-is-a-waterfall"}
          dateString={"9th May 2025"}
          shnoodleType={ShnoodleImageType.Waterfall}
        />
      </div>
    </div>
  );
};

export default StratusBlog;
